"use strict";

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("../style/style.css");
var _utils = require("../utils");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var LanguageSelectionModal = /*#__PURE__*/function (_react$default$PureCo) {
  function LanguageSelectionModal() {
    _classCallCheck(this, LanguageSelectionModal);
    return _callSuper(this, LanguageSelectionModal, arguments);
  }
  _inherits(LanguageSelectionModal, _react$default$PureCo);
  return _createClass(LanguageSelectionModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        onClose = _this$props.onClose,
        languageModalVisible = _this$props.languageModalVisible,
        project = _this$props.project,
        changeLocale = _this$props.changeLocale,
        logEvent = _this$props.logEvent;
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: !!languageModalVisible ? 'flex' : 'none',
          fontFamily: project.fonts[0].name
        },
        className: 'tsku-modal-container',
        onClick: onClose
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'tsku-modal',
        style: {
          background: project.language_selector_background_color,
          border: "1px solid ".concat(project.language_selector_border_color),
          color: project.language_selector_text_color
        }
      }, project.languages.map(function (language, idx) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: 'tsku-language-list',
          style: idx === 0 ? {} : {
            borderTop: "1px solid ".concat(project.language_selector_border_color)
          },
          key: language.code,
          onClick: function onClick() {
            logEvent('changeLocale', {
              languageCode: language.code
            });
            changeLocale(language.code);
            onClose();
          }
        }, project.language_selector_display_type === 'flag' && /*#__PURE__*/_react.default.createElement("div", {
          className: "tsk-flag-circle",
          style: {
            background: "url(\"".concat((0, _utils.flagUri)(project, language.code), "\") center center / cover"),
            marginRight: '0.5em'
          }
        }), language.local_name);
      })));
    }
  }]);
}(_react.default.PureComponent);
_defineProperty(LanguageSelectionModal, "whyDidYouRender", true);
var _default = exports.default = LanguageSelectionModal;